/* Gettmo v44: low-cost perceived-performance enhancements. */
(() => {
  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  const dataSaver = Boolean(connection?.saveData);
  const slowNetwork = /(^|-)2g$/.test(connection?.effectiveType || '');

  document.documentElement.classList.toggle('gettmo-data-saver', dataSaver || slowNetwork);

  // Warm likely product/collection navigation only after user intent.
  if (!dataSaver && !slowNetwork) {
    const warmed = new Set();
    const warm = (link) => {
      const href = link?.href;
      if (!href || warmed.has(href) || link.origin !== location.origin) return;
      if (!/\/(products|collections)\//.test(link.pathname)) return;
      warmed.add(href);
      const prefetch = document.createElement('link');
      prefetch.rel = 'prefetch';
      prefetch.href = href;
      const schedule = window.requestIdleCallback || ((callback) => setTimeout(callback, 1));
      schedule(() => document.head.appendChild(prefetch), { timeout: 600 });
    };
    document.addEventListener('pointerover', (event) => warm(event.target.closest('a')), { passive: true });
    document.addEventListener('touchstart', (event) => warm(event.target.closest('a')), { passive: true });
  }

  // Give immediate, accessible feedback while cart mutations are running.
  document.addEventListener('click', (event) => {
    const control = event.target.closest('cart-remove-button, quantity-input button, product-form button[type="submit"]');
    if (!control) return;
    control.setAttribute('aria-busy', 'true');
    window.setTimeout(() => control.removeAttribute('aria-busy'), 1200);
  }, { passive: true });
})();


// Restore transient busy states when returning from the browser back/forward cache.
window.addEventListener('pageshow', (event) => {
  if (!event.persisted) return;
  document.querySelectorAll('[aria-busy="true"]').forEach((element) => element.removeAttribute('aria-busy'));
  document.querySelectorAll('.cart__items--disabled').forEach((element) => element.classList.remove('cart__items--disabled'));
});
